<template>
  <b-modal
    v-model="mostrar"
    title="Escolha a Personalidade do Assistente"
    hide-footer
    size="lg"
  >
    <b-row>
      <b-col
        v-for="p in personalidades"
        :key="p.id"
        cols="12"
        md="6"
        @click="selecionar(p.id)"
      >
        <b-card
          :class="['mb-3', personalidadeSelecionada === p.id ? 'border-primary shadow' : '']"
          class="hover-card cursor-pointer h-100"
        >
          <div class="d-flex align-items-center">
            <!-- <img
                :src="p.imagem"
                alt="Imagem Personalidade"
                style="width: 50px; height: 50px;"
                class="mr-3 rounded-circle"
              /> -->
            <div>
              <h6 class="mb-1">
                {{ p.nome }}
              </h6>
              <small class="text-muted">{{ p.resumo }}</small>
            </div>
          </div>
        </b-card>
      </b-col>
    </b-row>

    <div
      v-if="personalidadeSelecionadaDetalhe"
      class="p-3 border rounded bg-light"
    >
      <h5>{{ personalidadeSelecionadaDetalhe.nome }}</h5>
      <p style="white-space: pre-wrap;">
        {{ personalidadeSelecionadaDetalhe.descricao }}
      </p>
    </div>

    <div class="text-right mt-3">
      <b-button
        variant="secondary"
        class="mr-2"
        @click="cancelar"
      >
        Cancelar
      </b-button>
      <b-button
        variant="primary"
        :disabled="personalidadeSelecionada === null"
        @click="confirmar"
      >
        Confirmar Personalidade
      </b-button>
    </div>
  </b-modal>
</template>

<script>
export default {
  name: 'SelecionarPersonalidade',
  props: {
    value: Number,
    show: Boolean,
  },
  data() {
    return {
      mostrar: this.show,
      personalidadeSelecionada: this.value,
      personalidades: [
        {
          id: 1,
          nome: 'Neutro',
          resumo: 'Direto ao ponto, profissional e objetivo.',
          descricao:
              'Um atendimento direto ao ponto, com foco em eficiência e clareza. O tom é educado, mas sem exagerar na simpatia. Ideal para lojas que preferem um contato mais objetivo, transmitindo profissionalismo e seriedade nas respostas.\n👉 Indicado para: Empresas que desejam agilidade e precisão nas interações.',
          imagem: 'https://cdn-icons-png.flaticon.com/512/4712/4712038.png',
        },
        {
          id: 2,
          nome: 'Empático',
          resumo: 'Acolhedor, emocional e muito humano.',
          descricao:
              'Atendimento com foco total no acolhimento emocional. O agente demonstra empatia em cada resposta, valida o sentimento do cliente e transmite cuidado e atenção. Usa uma linguagem gentil e envolvente, com toques sutis de emojis para reforçar o tom humano.\n👉 Indicado para: Marcas que querem transmitir proximidade, carinho e atenção ao cliente.',
          imagem: 'https://cdn-icons-png.flaticon.com/512/616/616408.png',
        },
        {
          id: 3,
          nome: 'Divertido',
          resumo: 'Leve, bem-humorado e criativo.',
          descricao:
              'Uma conversa com tom leve, descontraído e com pitadas de humor. O agente usa emojis de forma criativa, expressões divertidas e mantém a conversa animada, sem perder o foco na solução do problema.\n👉 Indicado para: Lojas com uma identidade jovem, casual ou com pegada de redes sociais.',
          imagem: 'https://cdn-icons-png.flaticon.com/512/3159/3159066.png',
        },
        {
          id: 4,
          nome: 'Jovem',
          resumo: 'Moderno, casual e com linguagem de app.',
          descricao:
              'Uma comunicação moderna, com linguagem casual, gírias leves e emojis no estilo de apps de mensagem. O agente responde de forma rápida, fluida e com um tom que lembra o de um amigo que trabalha na loja. Mantém a informalidade, mas sempre com respeito e objetividade.\n👉 Indicado para: E-commerces com público jovem, digital e acostumado com uma comunicação mais "internet friendly".',
          imagem: 'https://cdn-icons-png.flaticon.com/512/4140/4140037.png',
        },
      ],
    }
  },
  computed: {
    personalidadeSelecionadaDetalhe() {
      return this.personalidades.find(p => p.id === this.personalidadeSelecionada) || null
    },
  },
  watch: {
    show(val) {
      this.mostrar = val
    },
    mostrar(val) {
      this.$emit('update:show', val)
    },
    value(val) {
      this.personalidadeSelecionada = val
    },
  },
  methods: {
    selecionar(id) {
      this.personalidadeSelecionada = id
    },
    cancelar() {
      this.mostrar = false
    },
    confirmar() {
      this.$emit('input', this.personalidadeSelecionada)
      this.mostrar = false
    },
  },
}
</script>

  <style scoped>
  .hover-card {
    transition: box-shadow 0.3s, border-color 0.3s;
  }
  .hover-card:hover {
    box-shadow: 0 0 8px rgba(0, 123, 255, 0.3);
    border-color: #007bff;
    cursor: pointer;
  }
  </style>
